export interface StationAdjustmentData {
    stationAdjustmentXlsx: StationAdjustmentXlsx[] | null;
    stationAdjustmentXlsxName: string;
    layoutLayf: ArrayBuffer | null;
    layoutLayfName: string;
}

export interface StationAdjustmentXlsx {
    StationID: number;
    DepthOffset: number;
    SidewaysOffset: number;
    SidewaysSegmentsIn: number;
    SidewaysSegmentsOut: number;
}

export interface FileImportMessage {
    msg: string;
    success: boolean;
}

export interface BulkState {
    stationAdjustmentData: StationAdjustmentData;
}

export function EmptyBulkState(): BulkState {
    return {
        stationAdjustmentData: {
            layoutLayf: null,
            layoutLayfName: '',
            stationAdjustmentXlsx: null,
            stationAdjustmentXlsxName: '',
        },
    };
}
